import { getApiBaseUrl } from '../../../utils/apiConfig';

export async function fetchCxPublicRating(token) {
  const params = new URLSearchParams({ token });
  const res = await fetch(`${getApiBaseUrl()}/api/cx/public/rating?${params.toString()}`, {
    credentials: 'include',
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(json?.data?.message || json?.message || 'Não foi possível carregar a avaliação.');
  }
  return json.data;
}

function resolvePublicRatingToken(payload) {
  const fromPayload = String(payload?.ratingToken || payload?.token || '').trim();
  if (fromPayload) return fromPayload;
  if (typeof window !== 'undefined') {
    return new URLSearchParams(window.location.search).get('token') || '';
  }
  return '';
}

export async function submitCxPublicRating(payload) {
  const ratingToken = resolvePublicRatingToken(payload);
  if (!ratingToken) {
    throw new Error('Link inválido. Verifique o endereço recebido por e-mail.');
  }

  const { token: _token, ratingToken: _ratingToken, ...body } = payload || {};
  const params = new URLSearchParams({ token: ratingToken });
  const res = await fetch(`${getApiBaseUrl()}/api/cx/public/rating?${params.toString()}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(json?.message || 'Não foi possível enviar a avaliação.');
  }
  return json.data;
}

export function findRuleForStars(rules, stars) {
  const n = Number(stars);
  if (!Number.isFinite(n)) return null;
  return (rules || []).find((r) => n >= r.starsMin && n <= r.starsMax) || null;
}

export function isRatingFormComplete({
  stars,
  rule,
  motivId,
  selectedMotive,
  motivDetail,
  generalNote,
  noteOnMotive,
}) {
  if (!stars) return false;
  if (!rule) return true;

  if (rule.askReason) {
    if (!motivId) return false;
    if (selectedMotive?.requireDetail && !String(motivDetail || '').trim()) return false;
  }

  if (rule.requireNote && !String(generalNote || '').trim()) return false;

  if (rule.requireNoteOnMotive) {
    if (!motivId) return false;
    if (!String(noteOnMotive || '').trim()) return false;
  }

  return true;
}
